import * as React from 'react';
import QRStyledCard from 'ui-component/QRStyledCard';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ApiLink from 'API';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import SimpleBackdrop from 'ui-component/SimpleBackdrop';
import MailIcon from '@mui/icons-material/Mail';
import CallToActionIcon from '@mui/icons-material/CallToAction';
import {
    Alert,
    Avatar,
    Badge,
    Collapse,
    Divider,
    Fade,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputBase,
    InputLabel,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    Slide,
    Stack,
    TextField,
    Typography,
    useMediaQuery,
    Zoom
} from '@mui/material';
import TotalIncomeLightCard from 'ui-component/TotalIncomeLightCard';
import SubCard from 'ui-component/cards/SubCard';
import useSound from 'use-sound';
import CloseIcon from '@mui/icons-material/Close';
import peepSound from '../../../../assets/Barcode-scanner-beep-sound.mp3';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CameraIcon from '@mui/icons-material/Camera';
import DirectionsIcon from '@mui/icons-material/Directions';
import NumberFormat from 'react-number-format';
import { Box, styled, useTheme } from '@mui/system';
import DeleteIcon from '@mui/icons-material/Delete';
import PanoramaIcon from '@mui/icons-material/Panorama';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import BarcodeScanner from 'ui-component/BarcodeScanner';
import MessageBox from 'ui-component/MessageBox';
import IOSSwitch from 'ui-component/IOSSwitch';
import CoinAoneDark200 from '../../../../assets/images/CoinAoneDark200.png';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SelectProduct from './CompleteOrder/SelectProduct';
import PremiumsList from './CompleteOrder/premuims/PremiumsList';
import FormattedInputs from 'ui-component/FormattedInputs';
import AnnouncementDetect from './CompleteOrder/AnnouncementDetect';
import BulkImeiImport from './CompleteOrder/BulkImeiImport';
import BulkErrorPanel from './CompleteOrder/BulkErrorPanel';
import AutoPremiumsSummary from './CompleteOrder/AutoPremiumsSummary';
export default function CompleteOrder({ Open, setOpen, ReloadData, SelectedData }) {
    const [openBackdrop, setopenBackdrop] = React.useState(false);
    const [OpenSelectProduct, setOpenSelectProduct] = React.useState(false);
    const containerRef = React.useRef(null);
    const [AlertBox, setAlertBox] = React.useState({ open: false, message: '', severity: 'error' });
    const [ImeiProduct, setImeiProduct] = React.useState([]);
    const [Wallet, setWallet] = React.useState({ aone: false, credit: false });
    const [UseWalletAmount, setUseWalletAmount] = React.useState({ aoneWalletAmount: 0, creditAmount: 0, creditLimit: 0 });
    const [Step, setStep] = React.useState(0);
    const [TotalPrice, setTotalPrice] = React.useState(0);
    const [Description, setDescription] = React.useState('');
    const [Address, setAddress] = React.useState('');
    const [Delivery, setDelivery] = React.useState(1);
    const [RequestProduct, setRequestProduct] = React.useState([]);
    const [Premiumus, setPremiums] = React.useState([]);
    const [TotalPremiums, setTotalPremiums] = React.useState(0);
    // const [UsedAoneWallet, setUsedAoneWallet] = React.useState(0);
    const navigate = useNavigate();
    const [play] = useSound(peepSound, { volume: 0.5 });
    // --- LaoQR Payment State ---
    const [QRDialog, setQRDialog] = React.useState({ open: false, qrUrl: '', qrCode: '', qrPaymentId: '', shortId: '', chanel: '', customerID: '' });
    const [CustomerWhatsApp, setCustomerWhatsApp] = React.useState('');
    const [OpenQRAmountDialog, setOpenQRAmountDialog] = React.useState(false);
    const [QRAmountInput, setQRAmountInput] = React.useState(0);
    // Auto-cashback selection — populated by AnnouncementDetect
    const [SelectedAnnouncements, setSelectedAnnouncements] = React.useState([]);
    const [TotalCashback, setTotalCashback] = React.useState(0);
    // Full Eligible payload from AnnouncementDetect — keeps the pack/premium
    // breakdown that the auto-premium effect needs.
    const [EligibleAnnouncements, setEligibleAnnouncements] = React.useState([]);
    // Trigger for re-running cashback detection. Bumped when the user presses
    // Next so AnnouncementDetect re-evaluates against the actually-scanned
    // items, instead of firing on every IMEI scan.
    const [DetectVersion, setDetectVersion] = React.useState(0);
    // Forced-remount nonce — bumped after closing the bulk-import dialog so the
    // ProductOrder list rebuilds its DOM from scratch and avoids a layout glitch
    // where cards stay in stale positions after the dialog close transition.
    const [ListNonce, setListNonce] = React.useState(0);
    // Bulk-import errors surfaced OUTSIDE the dialog (it auto-closes on success).
    const [BulkErrors, setBulkErrors] = React.useState([]);

    // The set of products driving cashback detection + apply. Once IMEIs are
    // scanned this is the ACTUAL stock being sold (handles replacements/swaps
    // where the preorder request differs from what's delivered). Falls back
    // to the preorder snapshot when no IMEI has been scanned yet.
    const EffectiveRequestProduct = React.useMemo(() => {
        if (ImeiProduct.length > 0) {
            const grouped = ImeiProduct.reduce((acc, it) => {
                const pid = String(it?.productId || '');
                if (!pid) return acc;
                if (!acc[pid]) acc[pid] = { productId: pid, amount: 0 };
                acc[pid].amount += 1;
                return acc;
            }, {});
            return Object.values(grouped);
        }
        return (RequestProduct || []).map((r) => ({
            productId: String(r.productId),
            amount: Number(r.amount || 0),
        }));
    }, [ImeiProduct, RequestProduct]);

    // Auto-add premiums from the currently-selected announcements. Updates the
    // Premiumus list in TWO phases for snappy UX:
    //   1. Synchronously: re-compute the auto subset from `SelectedAnnouncements`
    //      and patch into Premiumus IMMEDIATELY (uses cached salePrice/img if
    //      previously fetched, otherwise placeholder until API responds).
    //   2. Async: fetch fresh stock/salePrice from /premiums/stock/selected and
    //      replace the placeholders.
    // Manual items the user added themselves are preserved.
    React.useEffect(() => {
        // Use the ENABLED packs (packsMatched) of each selected announcement so a
        // pack the user toggled off also drops its auto-premiums from the order.
        const need = {};
        (SelectedAnnouncements || []).forEach((sel) => {
            (sel.packsMatched || []).forEach((pack) => {
                (pack.premiums || []).forEach((pr) => {
                    if (!pr.premium_id) return;
                    const qty = Number(pr.qty || 0);
                    if (qty <= 0) return;
                    if (!need[pr.premium_id]) {
                        need[pr.premium_id] = { premium_id: pr.premium_id, premiumName: pr.premiumName || '', qty: 0 };
                    }
                    need[pr.premium_id].qty += qty;
                });
            });
        });
        const wanted = Object.values(need);

        // ── Phase 1: synchronous patch, runs on every selection toggle ──────
        setPremiums((prev) => {
            const manual = (prev || []).filter((p) => !p.__fromAnnouncement);
            const prevAuto = (prev || []).filter((p) => p.__fromAnnouncement);
            const newAuto = wanted.map((w) => {
                // Reuse previously-fetched enrichment (salePrice, img, stock).
                const existing = prevAuto.find((p) => p.premium_id === w.premium_id);
                if (existing) {
                    return { ...existing, amount: w.qty };
                }
                return {
                    premium_id: w.premium_id,
                    premiumName: w.premiumName,
                    salePrice: 0,
                    amount: w.qty,
                    __fromAnnouncement: true,
                    _placeholder: true,
                };
            });
            const autoIds = new Set(newAuto.map((f) => f.premium_id));
            return [...manual.filter((p) => !autoIds.has(p.premium_id)), ...newAuto];
        });

        if (wanted.length === 0) return;

        // ── Phase 2: async fetch for enrichment ─────────────────────────────
        const needsFetch = wanted.map((w) => w.premium_id);
        let cancelled = false;
        (async () => {
            try {
                const res = await axios.post(
                    ApiLink + '/api/premiums/stock/selected',
                    {
                        premium_id: needsFetch,
                        premiums: wanted.map((w) => ({ premium_id: w.premium_id, amount: w.qty })),
                    },
                    { withCredentials: true, headers: { token: localStorage.getItem('token') } },
                );
                if (cancelled) return;
                const fetched = (res.data?.data || []).reduce((acc, item) => {
                    acc[item.premium_id] = item;
                    return acc;
                }, {});
                setPremiums((prev) => (prev || []).map((p) => {
                    if (!p.__fromAnnouncement) return p;
                    const enriched = fetched[p.premium_id];
                    if (!enriched) return p;
                    return {
                        ...enriched,
                        __fromAnnouncement: true,
                        amount: need[p.premium_id]?.qty || p.amount,
                        _placeholder: false,
                    };
                }));
            } catch (err) {
                console.error('Auto-premium fetch error:', err.message);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [SelectedAnnouncements, EligibleAnnouncements]);

    // Normalize Lao phone → 856 + 20/30 + last8digits
    const normalizeLaoPhone = (phone) => {
        if (!phone) return '';
        const digits = phone.replace(/\D/g, '');
        let prefix = '20'; // default
        if (digits.startsWith('85630') || digits.startsWith('030') || (digits.startsWith('30') && digits.length <= 10)) {
            prefix = '30';
        } else if (digits.startsWith('85620') || digits.startsWith('020') || (digits.startsWith('20') && digits.length <= 10)) {
            prefix = '20';
        }
        const last8 = digits.slice(-8);
        return `856${prefix}${last8}`;
    };

    // Auto-fill WhatsApp from customer mobile
    React.useEffect(() => {
        if (SelectedData?.customers?.mobile) {
            setCustomerWhatsApp(normalizeLaoPhone(SelectedData.customers.mobile));
        }
    }, [SelectedData]);
    // --------------------------
    async function LoadAoneWallet(customerID) {
        if (Wallet.aone === true || Wallet.credit === true) {
            try {
                setopenBackdrop(true);
                const response = await axios.get(ApiLink + '/api/aonewallet/withcredit/' + customerID, {
                    withCredentials: true,
                    headers: {
                        token: localStorage.getItem('token')
                    }
                });
                // console.log(response.status);
                if (response.status === 200) {
                    const outcome = response.data.data?.aonewallets?.out;
                    const income = response.data.data?.aonewallets?.in;
                    const WalletTotal = income - outcome;
                    // console.log(outcome ? income - outcome : income ? income : 0);
                    const CreditLimit = response.data.data?.creditLimit - (response.data.data?.creditinvoices?.totalCredit || 0);
                    const WalletAmount = Wallet.aone ? (TotalPrice > WalletTotal ? WalletTotal : TotalPrice) : 0;
                    const CreditAmount = Wallet.credit ? (TotalPrice > WalletAmount ? TotalPrice - WalletAmount : 0) : 0;
                    // console.log(outcome ? income - outcome : income ? income : 0);
                    setUseWalletAmount({
                        ...UseWalletAmount,
                        aoneWalletAmount: WalletAmount,
                        creditAmount: CreditAmount,
                        creditLimit: CreditLimit
                    });

                    // console.log(response.data.data);
                    // settotal(response.data.total);
                } else if (response.status === 401) {
                    //got to login and clear token
                    localStorage.clear();
                    navigate(0);
                }
                setopenBackdrop(false);
            } catch (error) {
                console.log(error.response.body);
                MessageBox.open({
                    title: 'Error',
                    content: <p>{error.response.body}</p>,
                    buttons: [{ name: 'OK', handler: () => true }]
                });
                // if (error.response.status === 401) {
                //     localStorage.clear();
                //     navigate(0);
                // }
            }
            setopenBackdrop(false);
        } else if (Wallet.aone === false) {
            setUseWalletAmount({ ...UseWalletAmount, aoneWalletAmount: 0, creditAmount: 0 });
        } else {
        }
        setopenBackdrop(false);
    }
    const handleClose = async () => {
        const result = await MessageBox.open({
            title: 'Confirm',
            content: (
                <Stack direction="row">
                    <CheckCircleOutlineIcon color="primary" />
                    <Typography variant="body1" noWrap>
                        Do you want to close ?
                    </Typography>
                </Stack>
            ),
            buttons: [
                { name: 'Yes', handler: () => true },
                { name: 'No', handler: () => false }
            ]
        });
        // console.log(result);
        if (result) {
            setImeiProduct([]);
            setTotalPrice(0);
            setStep(0);
            setTotalPremiums(0);
            setPremiums([]);
            setDescription('');
            setAddress('');
            setAlertBox({ ...AlertBox, open: false });
            setWallet({ aone: false, samsung: false });
            setUseWalletAmount({ aoneWalletAmount: 0, creditAmount: 0 });
            setOpen(false);
        }
    };
    const handlePost = async () => {
        if (UseWalletAmount.aoneWalletAmount < TotalPrice && SelectedData.customers?.credit !== 1) {
            MessageBox.open({
                title: 'Warning',
                content: (
                    <Stack direction="row">
                        <WarningAmberIcon color="warning" />
                        <Typography variant="body1" noWrap>
                            You don't have enough money
                        </Typography>
                    </Stack>
                ),
                buttons: [{ name: 'Ok', handler: () => true }]
            });
            console.log(SelectedData);
        } else {
            setopenBackdrop(true);
            const _idArray = [];
            const IMEIArray = [];
            if (ImeiProduct.length !== 0 || Premiumus.length !== 0) {
                ImeiProduct.map((item) => {
                    _idArray.push(item.stockcontrollers._id);
                    IMEIArray.push(item.stockcontrollers.imei);
                });
                // Auto-added premiums ship at value=0 (they're free gifts); also
                // tag with isAuto so backend reporting can distinguish them.
                const PremiumsData = await Premiumus.map((p) => ({
                    premium_id: p.premium_id,
                    amount: p.amount,
                    referenceImage: '',
                    value: p.__fromAnnouncement ? 0 : p.salePrice,
                    isAuto: !!p.__fromAnnouncement,
                }));
                // const TotalPrice =
                //     ImeiProduct.length !== 0
                //         ? await ImeiProduct.map((item) => item.stockcontrollers.salePrice).reduce((prev, next) => prev + next)
                //         : 0;
                // console.log(IMEIArray);
                await axios
                    .put(
                        ApiLink + '/api/stockcontroller/salepreorder',
                        {
                            invoiceNumber: SelectedData?.invoiceRequest,
                            _id: _idArray,
                            imei: IMEIArray,
                            customerID: SelectedData?.customers.customerID,
                            paymentType: 2,
                            delivery: Delivery,
                            description: Description,
                            address: Address,
                            totalPayment: TotalPrice,
                            stock: -1,
                            aoneWalletAmount: UseWalletAmount?.aoneWalletAmount,
                            credit: UseWalletAmount?.creditAmount,
                            aoneWallet: Wallet.aone,
                            reference: '',
                            referenceImage: '',
                            premiums: PremiumsData,
                            totalPremiums: TotalPremiums,
                            // Pass v2 cashback snapshot so backend can validate the
                            // discounted totalPayment correctly (RealTotal - cashback).
                            selectedAnnouncements: SelectedAnnouncements
                        },
                        {
                            withCredentials: true,
                            headers: {
                                token: localStorage.getItem('token')
                            }
                        }
                    )
                    .then(async (res) => {
                        // Apply v2 auto-cashback after the sale is recorded.
                        // Non-QR path is sync — we fire-and-forget here; the
                        // creditNote + wallet credit are non-critical to the
                        // user-facing checkout flow, so a failure here just
                        // means the customer can't see cashback (not a sale
                        // failure).
                        let cashbackMsg = '';
                        try {
                            if (Array.isArray(SelectedAnnouncements) && SelectedAnnouncements.length > 0) {
                                const applyRes = await axios.post(
                                    ApiLink + '/api/aonewallet/announcement/apply',
                                    {
                                        customerID: SelectedData?.customers?.customerID,
                                        invoiceRequest: SelectedData?.invoiceRequest,
                                        requestProduct: EffectiveRequestProduct,
                                        selectedAnnouncements: SelectedAnnouncements
                                    },
                                    {
                                        withCredentials: true,
                                        headers: { token: localStorage.getItem('token') }
                                    }
                                );
                                const total = applyRes?.data?.data?.totalCashback || 0;
                                if (total > 0) {
                                    cashbackMsg = ` Cashback ₭${total.toLocaleString()} added to wallet.`;
                                }
                            }
                        } catch (cbErr) {
                            console.error('apply announcement error:', cbErr);
                        }
                        const result = await MessageBox.open({
                            title: 'Confirm',
                            content: (
                                <Stack direction="row">
                                    <CheckCircleOutlineIcon color="primary" />
                                    <Typography variant="body1" noWrap>
                                        Completed.{cashbackMsg}
                                    </Typography>
                                </Stack>
                            ),
                            buttons: [{ name: 'Ok', handler: () => true }]
                        });
                        // console.log(result);

                        setImeiProduct([]);
                        setPremiums([]);
                        setTotalPrice(0);
                        setStep(0);
                        setDescription('');
                        setAddress('');
                        setAlertBox({ ...AlertBox, open: false });
                        setWallet({ aone: false, credit: false });
                        setUseWalletAmount({ aoneWalletAmount: 0, creditAmount: 0 });
                        setOpen(false);
                        //reloadData
                        ReloadData('');

                        // console.log(res.data);
                        // setAlertBox({ open: true, message: 'Import successfully ReceiptID: ' + res.data.Receipt, severity: 'success' });
                    })
                    .catch((error) => {
                        console.log(error);
                        try {
                            setAlertBox({ open: true, message: error.response.data.msg, severity: 'error' });
                            // if (error.response.status === 400 || error.response.status === 500) {
                            //     setAlertBox({ open: true, message: error.response.data.msg, severity: 'error' });
                            //     // console.log(error.response.data.msg);
                            // } else if (error.response.status === 401) {
                            //     //got to login and clear token
                            //     localStorage.clear();
                            //     navigate(0);
                            // } else {
                            //     setAlertBox({ open: true, message: error.response.statusText, severity: 'error' });
                            //     // console.log(error.response.statusText);
                            // }
                        } catch (error) {
                            setAlertBox({ open: true, message: error, severity: 'error' });
                        }
                    });
                setopenBackdrop(false);
            } else {
                MessageBox.open({
                    title: 'Warning',
                    content: (
                        <Stack direction="row">
                            <WarningAmberIcon color="warning" />
                            <Typography variant="body1" noWrap>
                                You don't have Product
                            </Typography>
                        </Stack>
                    ),
                    buttons: [{ name: 'Ok', handler: () => true }]
                });
            }
            setopenBackdrop(false);
        }
    };

    // --- LaoQR Payment Handler ---
    const handleQRPost = async () => {
        if (ImeiProduct.length === 0 && Premiumus.length === 0) {
            MessageBox.open({
                title: 'Warning',
                content: (
                    <Stack direction="row">
                        <WarningAmberIcon color="warning" />
                        <Typography variant="body1" noWrap>You don't have Product</Typography>
                    </Stack>
                ),
                buttons: [{ name: 'Ok', handler: () => true }]
            });
            return;
        }
        // QR payment: no wallet balance check needed — QR itself is the payment source
        const _walletAmt = UseWalletAmount?.aoneWalletAmount || 0;
        const _creditAmt = UseWalletAmount?.creditAmount || 0;
        const _creditLimit = UseWalletAmount?.creditLimit || 0;
        // Cap credit at creditLimit if exceeded
        const _isCreditOverLimit = _creditLimit > 0 && _creditAmt > _creditLimit;
        const _cappedCredit = _isCreditOverLimit ? _creditLimit : _creditAmt;
        const walletOnly = _walletAmt > 0 && _cappedCredit === 0; // cases 2a & 2b
        const creditOnly = _cappedCredit > 0 && _walletAmt === 0; // case 4
        // If credit is over limit: QR is fixed (excess credit cannot be used)
        const isEditable = (walletOnly || creditOnly) && !_isCreditOverLimit;
        // For case 2a (wallet partial): min QR = Total - wallet
        const _minQR = (walletOnly && _walletAmt < TotalPrice) ? (TotalPrice - _walletAmt) : 0;
        // Initial QR: start at minQR if editable, else auto = Total - wallet - cappedCredit
        const _initialQR = isEditable ? _minQR : Math.max(0, TotalPrice - _walletAmt - _cappedCredit);
        setQRAmountInput(_initialQR);
        setOpenQRAmountDialog(true);
    };

    const handleQRSubmit = async () => {
        setOpenQRAmountDialog(false);
        setopenBackdrop(true);
        // Clear any stale alert from a previous attempt — otherwise the old
        // error message sticks around after a successful retry.
        setAlertBox({ open: false, message: '', severity: 'error' });
        try {
            const _idArray = [];
            const IMEIArray = [];
            ImeiProduct.forEach((item) => {
                _idArray.push(item.stockcontrollers._id);
                IMEIArray.push(item.stockcontrollers.imei);
            });
            // Auto-added premiums ship at value=0 (free gift); tagged isAuto.
            const PremiumsData = Premiumus.map((p) => ({
                premium_id: p.premium_id,
                amount: p.amount,
                referenceImage: '',
                value: p.__fromAnnouncement ? 0 : p.salePrice,
                isAuto: !!p.__fromAnnouncement,
            }));
            // Compute effective wallet/credit — cap credit at creditLimit if exceeded
            const _wAmt = UseWalletAmount?.aoneWalletAmount || 0;
            const _cAmt = UseWalletAmount?.creditAmount || 0;
            const _cLimit = UseWalletAmount?.creditLimit || 0;
            const _cappedCredit = (_cLimit > 0 && _cAmt > _cLimit) ? _cLimit : _cAmt;
            const walletOnly = _wAmt > 0 && _cappedCredit === 0;
            const creditOnly = _cappedCredit > 0 && _wAmt === 0;
            const _isCreditOverLimit = _cLimit > 0 && _cAmt > _cLimit;
            let _effectiveWallet, _effectiveCredit;
            if (walletOnly && !_isCreditOverLimit) {
                // Cases 2a & 2b: wallet covers what QR doesn't, capped at available wallet
                _effectiveWallet = Math.min(_wAmt, Math.max(0, TotalPrice - QRAmountInput));
                _effectiveCredit = 0;
            } else if (creditOnly && !_isCreditOverLimit) {
                // Case 4: credit covers what QR doesn't (capped credit already applied)
                _effectiveWallet = 0;
                _effectiveCredit = Math.max(0, TotalPrice - QRAmountInput);
            } else {
                // Fixed cases (mixed, no sources, or credit over limit)
                _effectiveWallet = _wAmt;
                _effectiveCredit = _cappedCredit; // send capped credit to backend
            }
            const response = await axios.post(
                ApiLink + '/api/stockcontroller/salepreorder/qrpayment',
                {
                    invoiceNumber: SelectedData?.invoiceRequest,
                    shortId: SelectedData?.invoiceRequest,
                    _id: _idArray,
                    imei: IMEIArray,
                    customerID: SelectedData?.customers.customerID,
                    customerWhatsApp: CustomerWhatsApp,
                    paymentType: 2,
                    delivery: Delivery,
                    description: Description,
                    address: Address,
                    totalPayment: TotalPrice,
                    qrAmount: QRAmountInput,
                    stock: -1,
                    aoneWalletAmount: _effectiveWallet,
                    credit: _effectiveCredit,
                    aoneWallet: Wallet.aone,
                    reference: '',
                    referenceImage: '',
                    premiums: PremiumsData,
                    totalPremiums: TotalPremiums,
                    // Carry the auto-cashback selection through to the QR webhook.
                    // paymentHandler re-validates and applies once payment lands.
                    selectedAnnouncements: SelectedAnnouncements,
                    requestProduct: EffectiveRequestProduct
                },
                { withCredentials: true, headers: { token: localStorage.getItem('token') } }
            );
            if (response.status === 201) {
                // QR Payment is created with status='pending' — Finance must verify
                // before the QR is sent to the customer. Don't show the QR to Sales
                // here; just confirm submission and close the page.
                setAlertBox({ open: false, message: '', severity: 'error' });
                await MessageBox.open({
                    title: 'QR Payment ສ້າງສຳເລັດ',
                    content: (
                        <Stack direction="row" spacing={1}>
                            <CheckCircleOutlineIcon color="primary" />
                            <Typography variant="body1">
                                ສົ່ງໃຫ້ Finance ກວດສອບແລ້ວ. ລູກຄ້າຈະໄດ້ຮັບ QR ຫລັງຈາກ Finance ອະນຸມັດ.
                            </Typography>
                        </Stack>
                    ),
                    buttons: [{ name: 'OK', handler: () => true }],
                });
                setOpen(false);
                ReloadData('');
            }
        } catch (error) {
            const msg = error?.response?.data?.msg || 'เกิดข้อผิดพลาด';
            setAlertBox({ open: true, message: msg, severity: 'error' });
        } finally {
            setopenBackdrop(false);
        }
    };
    const handleSubmitIMEI = async (IMEI, productId) => {
        try {
            setopenBackdrop(true);
            play();
            setAlertBox({
                open: false,
                message: '',
                severity: 'error'
            });
            const IMEICHECK = IMEI !== '' ? IMEI : '0';
            const productIdCHECK = productId !== '' ? productId : '0';
            const response = await axios.get(ApiLink + '/api/stockcontroller/stock/imei/' + productIdCHECK + '/' + IMEICHECK, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                const DataProduct = response.data.data;
                // console.log(response.data.data);
                if (DataProduct.length !== 0) {
                    const uniqueIMEI = ImeiProduct.find((x) => x.stockcontrollers.imei === DataProduct[0].stockcontrollers.imei);
                    if (uniqueIMEI === undefined) {
                        // const newImei = { ...DataProduct[0], images: [{ img: '' }] };
                        setImeiProduct([...ImeiProduct, DataProduct[0]]);
                    } else {
                        setAlertBox({
                            open: true,
                            message: 'Duplicate: IMEI ' + IMEI + ' is Duplicate',
                            severity: 'error'
                        });
                    }
                } else {
                    setAlertBox({
                        open: true,
                        message: 'IMEI ' + IMEI + ' is wrong on Product : ' + productIdCHECK,
                        severity: 'error'
                    });
                }

                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
                setopenBackdrop(false);
            } else {
                setAlertBox({
                    open: true,
                    message: response.status,
                    severity: 'error'
                });
                setopenBackdrop(false);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            setAlertBox({
                open: true,
                message: error,
                severity: 'error'
            });
            setopenBackdrop(false);
        }
    };
    React.useEffect(() => {
        // if (ImeiProduct.length !== 0) {
        const total =
            ImeiProduct.length !== 0 ? ImeiProduct.map((item) => item.stockcontrollers.salePrice).reduce((prev, next) => prev + next) : 0;
        setTotalPrice(total + TotalPremiums - TotalCashback);
        // } else {
        //     setTotalPrice(TotalPremiums);
        // }
    }, [ImeiProduct, TotalPremiums, TotalCashback]);
    React.useEffect(() => {
        LoadAoneWallet(SelectedData.customers?.customerID);
    }, [Step, Wallet, TotalPrice]);
    // React.useEffect(() => {
    //     console.log(Wallet.aone);
    // }, [Wallet]);
    React.useEffect(() => {
        // Auto-added (from announcement) premiums are FREE gifts — exclude them
        // from the total the customer is charged. They still ship + still
        // decrement stock; they just don't count toward totalPayment.
        const billable = (Premiumus || []).filter((item) => !item.__fromAnnouncement);
        const PremiumsPrice = billable.length !== 0
            ? billable.map((item) => item.salePrice * item.amount).reduce((prev, next) => prev + next, 0)
            : 0;
        setTotalPremiums(PremiumsPrice);
    }, [Premiumus]);
    React.useEffect(async () => {
        setRequestProduct(() => {
            return Object.keys(SelectedData).length !== 0 ? SelectedData?.requestProduct : [];
        });
        if (Array.isArray(SelectedData?.premiums) && SelectedData.premiums.length > 0 && Object.keys(SelectedData).length !== 0) {
            await LoadPremiumsStock();
        }

        // console.log(SelectedData?.requestProduct);
    }, [SelectedData]);
    async function LoadPremiumsStock() {
        setopenBackdrop(true);
        const premium_ids = [];
        await (SelectedData?.premiums || []).map((item) => {
            premium_ids.push(item.premium_id);
        });
        console.log(premium_ids);
        const response = await axios.post(
            ApiLink + '/api/premiums/stock/selected',
            { premium_id: premium_ids, premiums: SelectedData?.premiums },
            {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            }
        );
        if (response.status === 200) {
            setPremiums(response.data.data);
        }
        setopenBackdrop(false);
    }
    return (
        <div>
            <Dialog
                open={Open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen
                disableEnforceFocus
                keepMounted
            >
                <div id="app-message-box" />
                <SimpleBackdrop open={openBackdrop} />
                <DialogTitle id="alert-dialog-title">
                    <Stack direction="row" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="caption" sx={{ color: 'green' }}>
                            {'Complete preoder ID: ' + SelectedData?.invoiceRequest + ''}
                        </Typography>
                        <Typography variant="subtitle1">{'' + SelectedData.customers?.customerName + ''}</Typography>
                    </Stack>
                </DialogTitle>

                <DialogContent ref={containerRef}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <SelectProduct
                                open={OpenSelectProduct}
                                setOpen={setOpenSelectProduct}
                                openBackdrop={openBackdrop}
                                setopenBackdrop={setopenBackdrop}
                                setData={(para) => {
                                    const uniqueModel = RequestProduct.find((x) => x.model === para.model);
                                    console.log(para);
                                    console.log(uniqueModel);
                                    if (uniqueModel === undefined) {
                                        setRequestProduct([
                                            ...RequestProduct,
                                            {
                                                _id: para._id,
                                                productId: para.productId,
                                                amount: 1,
                                                price: para.promotionPrice,
                                                productName: para.productName,
                                                model: para.model
                                            }
                                        ]);
                                    }
                                }}
                            />
                            <Collapse in={AlertBox.open}>
                                <Alert
                                    sx={{ padding: '10px', mb: 2 }}
                                    // variant="outlined"
                                    severity={AlertBox.severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setAlertBox({ ...AlertBox, open: false });
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                >
                                    {AlertBox.message}
                                </Alert>
                            </Collapse>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Stack direction="column" spacing={0}>
                                    <Stack direction="row" spacing={1} alignItems="baseline">
                                        <Typography variant="h2" noWrap color="gray">
                                            Total :
                                        </Typography>
                                        <Typography variant="h2" color="#f57224">
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={TotalPrice.toFixed(2)}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                            />
                                        </Typography>
                                    </Stack>
                                    {TotalCashback > 0 && (
                                        <Stack direction="row" spacing={1} alignItems="baseline" sx={{ pl: 0.5 }}>
                                            <Typography
                                                variant="body2"
                                                color="gray"
                                                sx={{ textDecoration: 'line-through' }}
                                            >
                                                <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={(TotalPrice + TotalCashback).toFixed(2)}
                                                    prefix="₭"
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                />
                                            </Typography>
                                            <Typography variant="caption" sx={{ color: '#2E7D32', fontWeight: 700 }}>
                                                − ₭
                                                <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={TotalCashback}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                />
                                                {' cashback'}
                                            </Typography>
                                        </Stack>
                                    )}
                                </Stack>
                                <IconButton
                                    aria-label="cart"
                                    onClick={() => {
                                        MessageBox.open({
                                            title: 'Description',
                                            content: <Typography variant="body">{SelectedData.description}</Typography>,
                                            buttons: [{ name: 'OK', handler: () => true }]
                                        });
                                    }}
                                >
                                    <Badge badgeContent={SelectedData.description !== '' ? 1 : 0} color="primary">
                                        <MailIcon />
                                    </Badge>
                                </IconButton>
                            </Stack>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <TotalIncomeLightCard isLoading={false} dataCustomer={SelectedData?.customers} />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <AnnouncementDetect
                                customerID={SelectedData?.customers?.customerID}
                                invoiceRequest={SelectedData?.invoiceRequest}
                                requestProduct={EffectiveRequestProduct}
                                detectVersion={DetectVersion}
                                onChange={(sel, total, eligible) => {
                                    setSelectedAnnouncements(sel);
                                    setTotalCashback(total);
                                    setEligibleAnnouncements(Array.isArray(eligible) ? eligible : []);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <AutoPremiumsSummary
                                Premiumus={Premiumus}
                                SelectedAnnouncements={SelectedAnnouncements}
                                EligibleAnnouncements={EligibleAnnouncements}
                            />
                        </Grid>
                        <Slide direction="right" in={Step === 0 ? true : false} container={containerRef.current}>
                            <Grid item xs={12} sm={12}>
                                <Collapse in={Step === 0 ? true : false}>
                                    {Object.keys(SelectedData).length !== 0
                                        ? RequestProduct.map((item, idx) => {
                                            // Bundle ListNonce into the key so closing the bulk-import
                                            // dialog forces ProductOrder to remount — the cards otherwise
                                            // get stuck in a stale layout after the dialog's close
                                            // transition (state is correct, DOM is not).
                                            return (
                                                <ProductOrder
                                                    key={`${item?.productId || item?._id || idx}-${ListNonce}`}
                                                    item={item}
                                                    handleSubmitIMEI={handleSubmitIMEI}
                                                    ImeiProduct={ImeiProduct}
                                                    setImeiProduct={setImeiProduct}
                                                />
                                            );
                                        })
                                        : null}
                                    <Button
                                        variant="outlined"
                                        color="info"
                                        sx={{ marginTop: 5 }}
                                        onClick={() => {
                                            setOpenSelectProduct(true);
                                        }}
                                        startIcon={<AddShoppingCartIcon />}
                                    >
                                        Add More
                                    </Button>
                                    <BulkImeiImport
                                        RequestProduct={RequestProduct}
                                        ImeiProduct={ImeiProduct}
                                        setImeiProduct={setImeiProduct}
                                        onClosed={() => setListNonce((n) => n + 1)}
                                        onErrors={(errs) => setBulkErrors(errs || [])}
                                    />
                                    <BulkErrorPanel
                                        errors={BulkErrors}
                                        onDismiss={() => setBulkErrors([])}
                                    />
                                </Collapse>
                            </Grid>
                        </Slide>
                        {/* <Slide direction="right" in={Step === 0 ? true : false} container={containerRef.current}> */}
                        <Grid item xs={12} sm={12}>
                            <Collapse in={Step === 0 ? true : false}>
                                <PremiumsList Premiumus={Premiumus} setPremiums={setPremiums} />
                            </Collapse>
                        </Grid>
                        {/* </Slide> */}
                        {/* for Step1 */}
                        {/* <Slide direction="right" in={Step === 1 ? true : false} container={containerRef.current}> */}
                        <Grid item xs={12} sm={12} md={6}>
                            <Collapse in={Step === 1 ? true : false}>
                                <Stack>
                                    <Paper elevation={1} sx={{ padding: '5px' }}>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    sx={{ m: 1 }}
                                                    checked={Wallet.aone}
                                                    onChange={(e) => setWallet({ ...Wallet, aone: e.target.checked })}
                                                />
                                            }
                                            label={
                                                <Stack direction="row" spacing={1}>
                                                    <Avatar
                                                        alt="Aone Coin"
                                                        src={CoinAoneDark200}
                                                        sx={{ width: 20, height: 20, background: 'transparent' }}
                                                    />
                                                    <Typography
                                                        variant="subtitle1"
                                                        sx={{
                                                            color: '#3035BC'
                                                        }}
                                                    >
                                                        {Wallet.aone === true ? (
                                                            <NumberFormat
                                                                thousandsGroupStyle="thousand"
                                                                value={UseWalletAmount?.aoneWalletAmount}
                                                                prefix=""
                                                                decimalSeparator="."
                                                                displayType="text"
                                                                type="text"
                                                                thousandSeparator={true}
                                                                allowNegative={true}
                                                            />
                                                        ) : (
                                                            'Used A-one Wallet'
                                                        )}
                                                    </Typography>
                                                </Stack>
                                            }
                                        />
                                    </Paper>
                                </Stack>
                            </Collapse>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Collapse in={Step === 1 && SelectedData.customers?.credit === 1 ? true : false}>
                                <Stack>
                                    <Paper elevation={1} sx={{ padding: '5px' }}>
                                        <FormControlLabel
                                            control={
                                                <IOSSwitch
                                                    sx={{ m: 1 }}
                                                    checked={Wallet.credit}
                                                    onChange={(e) => setWallet({ ...Wallet, credit: e.target.checked })}
                                                />
                                            }
                                            label={
                                                <Stack direction="row" spacing={1}>
                                                    <CallToActionIcon
                                                        sx={{
                                                            color:
                                                                UseWalletAmount?.creditAmount > UseWalletAmount?.creditLimit
                                                                    ? 'red'
                                                                    : '#f57224',
                                                            width: 20,
                                                            height: 20,
                                                            background: 'transparent'
                                                        }}
                                                    />
                                                    <Stack direction="row">
                                                        {Wallet.credit === true ? (
                                                            <>
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{
                                                                        color:
                                                                            UseWalletAmount?.creditAmount > UseWalletAmount?.creditLimit
                                                                                ? 'red'
                                                                                : '#f57224'
                                                                    }}
                                                                >
                                                                    <NumberFormat
                                                                        thousandsGroupStyle="thousand"
                                                                        value={UseWalletAmount?.creditAmount}
                                                                        prefix=""
                                                                        decimalSeparator="."
                                                                        displayType="text"
                                                                        type="text"
                                                                        thousandSeparator={true}
                                                                        allowNegative={true}
                                                                    />
                                                                </Typography>
                                                                <Typography variant="button">/</Typography>
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{
                                                                        color:
                                                                            UseWalletAmount?.creditAmount > UseWalletAmount?.creditLimit
                                                                                ? 'red'
                                                                                : 'black'
                                                                    }}
                                                                >
                                                                    <NumberFormat
                                                                        thousandsGroupStyle="thousand"
                                                                        value={UseWalletAmount?.creditLimit}
                                                                        prefix=""
                                                                        decimalSeparator="."
                                                                        displayType="text"
                                                                        type="text"
                                                                        thousandSeparator={true}
                                                                        allowNegative={true}
                                                                    />
                                                                </Typography>
                                                            </>
                                                        ) : (
                                                            <Typography
                                                                variant="subtitle1"
                                                                sx={{
                                                                    color: '#f57224'
                                                                }}
                                                            >
                                                                Use Credit
                                                            </Typography>
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            }
                                        />
                                    </Paper>
                                </Stack>
                            </Collapse>
                        </Grid>
                        {/* </Slide> */}
                        <Slide direction="right" in={Step === 1 ? true : false} container={containerRef.current}>
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Delivery</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        name="delivery"
                                        value={Delivery}
                                        label="Delivery"
                                        onChange={(e) => {
                                            setDelivery(e.target.value);
                                        }}
                                    // sx={{ ...theme.typography.customInput, height: 62 }}
                                    >
                                        <MenuItem value={1}>NONE</MenuItem>
                                        <MenuItem value={2}>Flash</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Slide>
                        <Slide direction="right" in={Step === 1 ? true : false} container={containerRef.current}>
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    // margin="normal"
                                    name="description"
                                    type="text"
                                    multiline
                                    rows={3}
                                    // variant="standard"
                                    defaultValue=""
                                    value={Description}
                                    onChange={(e) => {
                                        setDescription(e.target.value);
                                    }}
                                // sx={{ ...theme.typography.customInput }}
                                />
                            </Grid>
                        </Slide>
                        <Slide direction="right" in={Step === 1 ? true : false} container={containerRef.current}>
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    fullWidth
                                    label="Shippig Address"
                                    // margin="normal"
                                    name="description"
                                    type="text"
                                    multiline
                                    rows={4}
                                    // variant="standard"
                                    defaultValue=""
                                    value={Address}
                                    onChange={(e) => {
                                        setAddress(e.target.value);
                                    }}
                                // sx={{ ...theme.typography.customInput }}
                                />
                            </Grid>
                        </Slide>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Box>
                        {Step === 0 ? (
                            <Button sx={{ marginRight: 5 }} color="error" variant="outlined" onClick={handleClose}>
                                Cancel
                            </Button>
                        ) : Step === 1 ? (
                            <Button
                                sx={{ marginRight: 5 }}
                                color="info"
                                variant="outlined"
                                onClick={() => {
                                    setStep(0);
                                }}
                            >
                                Back
                            </Button>
                        ) : null}

                        {Step === 0 ? (
                            <Button
                                variant="contained"
                                color="primary"
                                // startIcon={<ShoppingCartIcon />}
                                // onClick={SubmitDelete}
                                onClick={() => {
                                    // Re-run cashback detection against the actually-scanned
                                    // items before moving on. Detection itself is async; the
                                    // parent still transitions to step 1 immediately.
                                    setDetectVersion((v) => v + 1);
                                    setStep(1);
                                }}
                            >
                                Next
                            </Button>
                        ) : Step === 1 ? (<>
                            <Button
                                sx={{ marginRight: 5 }}
                                color="success"
                                variant="outlined"
                                startIcon={<ShoppingCartIcon />}
                                onClick={handlePost}
                            >
                                Finish
                            </Button>
                            <Button
                                sx={{ marginRight: 1 }}
                                color="warning"
                                variant="contained"
                                startIcon={<span style={{ fontSize: 16 }}>🏧</span>}
                                onClick={handleQRPost}
                            >
                                LaoQR
                            </Button>
                        </>
                        ) : null}
                    </Box>
                </DialogActions>
            </Dialog>

            {/* LaoQR Amount Input Dialog */}
            {(() => {
                const _walletAmt = UseWalletAmount?.aoneWalletAmount || 0;
                const _creditAmt = UseWalletAmount?.creditAmount || 0;
                const _creditLimit = UseWalletAmount?.creditLimit || 0;
                const _isCreditOverLimit = _creditLimit > 0 && _creditAmt > _creditLimit;
                const _cappedCredit = _isCreditOverLimit ? _creditLimit : _creditAmt;
                const walletOnly = _walletAmt > 0 && _cappedCredit === 0;
                const creditOnly = _cappedCredit > 0 && _walletAmt === 0;
                const isQRFixed = (!walletOnly && !creditOnly) || _isCreditOverLimit;
                // Minimum QR: for case 2a wallet is partial — user can't go below (Total - wallet)
                const minQR = (walletOnly && _walletAmt < TotalPrice && !_isCreditOverLimit) ? (TotalPrice - _walletAmt) : 0;
                const effectiveMinQR = Math.max(1000, minQR);
                // Dynamic display amounts
                const _effectiveWallet = walletOnly
                    ? Math.min(_walletAmt, Math.max(0, TotalPrice - QRAmountInput))
                    : _walletAmt;
                const _effectiveCredit = creditOnly
                    ? Math.max(0, TotalPrice - QRAmountInput)
                    : _cappedCredit;
                return (
                    <Dialog open={OpenQRAmountDialog} onClose={() => setOpenQRAmountDialog(false)} maxWidth="xs" fullWidth>
                        <DialogTitle>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <span>🏧</span>
                                <Typography variant="h4">ກຳນົດຈຳນວນເງີນ QR Payment</Typography>
                            </Stack>
                        </DialogTitle>
                        <DialogContent>
                            <Stack spacing={2} sx={{ pt: 1 }}>
                                {/* Order Total */}
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Typography variant="subtitle2" color="gray" sx={{ minWidth: 90 }}>ຍອດລວມໃບສັ່ງ:</Typography>
                                    <Typography variant="h4" color="#0c4da2">
                                        <NumberFormat thousandsGroupStyle="thousand" value={TotalPrice} prefix="₭" decimalSeparator="." displayType="text" thousandSeparator={true} />
                                    </Typography>
                                </Stack>

                                {/* Wallet row */}
                                {_walletAmt > 0 && (
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <Typography variant="subtitle2" color="gray" sx={{ minWidth: 90 }}>Wallet:</Typography>
                                        <Typography variant="h5" color="#3035BC">
                                            ₭{_effectiveWallet.toLocaleString()}
                                            {walletOnly && <Typography component="span" variant="caption" color="textSecondary"> (auto)</Typography>}
                                        </Typography>
                                    </Stack>
                                )}

                                {/* Credit row */}
                                {_creditAmt > 0 && (
                                    <Stack spacing={0.5}>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Typography variant="subtitle2" color="gray" sx={{ minWidth: 90 }}>Credit:</Typography>
                                            <Typography variant="h5" color={_isCreditOverLimit ? 'error.main' : '#f57224'}>
                                                ₭{_effectiveCredit.toLocaleString()}
                                                {creditOnly && !_isCreditOverLimit && <Typography component="span" variant="caption" color="textSecondary"> (auto)</Typography>}
                                                {_isCreditOverLimit && <Typography component="span" variant="caption" color="textSecondary"> / ₭{_creditAmt.toLocaleString()}</Typography>}
                                            </Typography>
                                        </Stack>
                                        {_isCreditOverLimit && (
                                            <Typography variant="caption" color="error">
                                                ⚠️ Credit ເກີນ Limit ₭{_creditLimit.toLocaleString()} — ສ່ວນເກີນ ₭{(_creditAmt - _creditLimit).toLocaleString()} ຈ່າຍຜ່ານ QR
                                            </Typography>
                                        )}
                                    </Stack>
                                )}

                                {/* QR Amount */}
                                {isQRFixed ? (
                                    // Read-only: auto computed (Case 1 mixed, Case 3 no sources)
                                    <Stack spacing={0.5}>
                                        <Typography variant="subtitle2" color="gray">ຈ່າຍຜ່ານ QR (LAK):</Typography>
                                        <Typography variant="h2" color="#f57224" sx={{ fontWeight: 700 }}>
                                            ₭{QRAmountInput.toLocaleString()}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">🔒 ກຳນົດອັດຕະໂນມັດ</Typography>
                                    </Stack>
                                ) : (
                                    // Editable: Cases 2a, 2b, 4
                                    <Stack spacing={0.5}>
                                        <Typography variant="subtitle2" color="gray">ຈ່າຍຜ່ານ QR (LAK):</Typography>
                                        <FormattedInputs
                                            fullWidth
                                            label="ກຳນົດຈຳນວນ QR"
                                            name="qrAmount"
                                            id="qr-amount-input"
                                            value={QRAmountInput}
                                            onChange={(e) => {
                                                const val = Number(e.target.value) || 0;
                                                // Enforce min (case 2a) and max (TotalPrice)
                                                const clamped = Math.min(Math.max(val, minQR), TotalPrice);
                                                setQRAmountInput(clamped);
                                            }}
                                            sx={{ input: { color: '#f57224', fontSize: 22, fontWeight: 700 } }}
                                        />
                                        <Typography variant="caption" color="textSecondary">
                                            ✏️ ເລືອກໄດ້ |{walletOnly ? ` Wallet ຈ່າຍ: ₭${_effectiveWallet.toLocaleString()}` : ` Credit ຈ່າຍ: ₭${_effectiveCredit.toLocaleString()}`} (auto)
                                            {minQR > 0 && ` | ຕ່ຳສຸດ: ₭${minQR.toLocaleString()}`}
                                        </Typography>
                                        {QRAmountInput > 0 && QRAmountInput < effectiveMinQR && (
                                            <Typography variant="caption" color="error">
                                                ⚠️ ຈຳນວນ QR ຕ່ຳສຸດ ₭{effectiveMinQR.toLocaleString()}
                                            </Typography>
                                        )}
                                    </Stack>
                                )}
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            <Button color="secondary" onClick={() => setOpenQRAmountDialog(false)}>Cancel</Button>
                            <Button
                                color="warning"
                                variant="contained"
                                startIcon={<span>🏧</span>}
                                onClick={handleQRSubmit}
                                disabled={QRAmountInput < effectiveMinQR}
                            >
                                ສ້າງ QR Payment
                            </Button>
                        </DialogActions>
                    </Dialog>
                );
            })()}

            {/* LaoQR Payment Result Dialog */}
            <QRPaymentDialog
                open={QRDialog.open}
                onClose={() => { setQRDialog({ ...QRDialog, open: false }); setOpen(false); ReloadData(''); }}
                qrUrl={QRDialog.qrUrl}
                qrCode={QRDialog.qrCode}
                shortId={QRDialog.shortId}
                qrPaymentId={QRDialog.qrPaymentId}
                customerID={QRDialog.customerID}
                CustomerWhatsApp={CustomerWhatsApp}
                setCustomerWhatsApp={setCustomerWhatsApp}
            />
        </div>
    );
}

// Ensure this is after the default export function
function QRPaymentDialog({ open, onClose, qrUrl, qrCode, shortId, qrPaymentId, customerID, CustomerWhatsApp, setCustomerWhatsApp }) {
    // Validate: must be 85620xxxxxxxx or 85630xxxxxxxx (13 digits)
    const phoneValid = /^8562[03]\d{8}$/.test(CustomerWhatsApp);
    const phoneError = CustomerWhatsApp && !phoneValid
        ? 'ເບີຕ້ອງຢູ່ໃນຮູບແບບ 85620XXXXXXXX ຫຼື 85630XXXXXXXX'
        : '';
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Stack direction="row" spacing={1} alignItems="center">
                    <span>🏧</span>
                    <Typography variant="h4">LaoQR Payment</Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2} alignItems="center">
                    <TextField
                        fullWidth
                        size="small"
                        label="WhatsApp ລູກຄ້າ (85620XXXXXXXX)"
                        value={CustomerWhatsApp}
                        onChange={(e) => setCustomerWhatsApp(e.target.value)}
                        placeholder="85620XXXXXXXX"
                        error={!!phoneError}
                        helperText={phoneError || `ລະຫັດລູກຄ້າ: ${CustomerWhatsApp || '-'}`}
                        inputProps={{ maxLength: 13 }}
                    />
                    {(qrCode || qrUrl) ? (
                        <>
                            <Typography variant="body2" color="textSecondary">ສະແກນ QR ດ້ານລ່າງຜ່ານ BCEL OnePay</Typography>
                            {qrCode ? (
                                <QRStyledCard
                                    qrString={qrCode}
                                    mcname="A-One Dristributors Co.,LTD"
                                    username={customerID || shortId || 'CUSTOMER'}
                                    size={240}
                                />
                            ) : (
                                <Box
                                    component="img"
                                    src={qrUrl}
                                    alt="LaoQR Code"
                                    sx={{ width: 240, height: 240, border: '1px solid #ccc', borderRadius: 2 }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                />
                            )}
                            <Typography variant="caption" color="textSecondary">
                                Invoice: {shortId}
                            </Typography>
                            <Typography variant="caption" color="warning.main">
                                ⏰ QR ໝົດອາຍຸໃນ 24 ຊົ່ວໂມງ
                            </Typography>
                        </>
                    ) : null}
                    <Alert severity="info" sx={{ width: '100%' }}>
                        ຫຼັງຈາກສ້າງ QR ແລ້ວ Manager ຕ້ອງ Approve ກ່ອນ ລູກຄ້າຈຶ່ງຈະໄດ້ຮັບ QR ທາງ WhatsApp
                    </Alert>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">ປິດ</Button>
            </DialogActions>
        </Dialog>
    );
}

/////////////////////////////////////////////////////////////////////////////
const ListItemWrapper = styled('div')(({ theme }) => ({
    cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));
const ProductOrder = ({ item, handleSubmitIMEI, ImeiProduct, setImeiProduct }) => {
    const [ImeiScan, setImeiScan] = React.useState('');

    const [ScanOpen, setScanOpen] = React.useState(false);
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    // Derive from ImeiProduct directly — avoids the "local state out of sync
    // with prop" issue that would manifest as cards disappearing on parent
    // re-renders (e.g. closing the bulk-import dialog).
    const DataProduct = React.useMemo(
        () => (ImeiProduct || []).filter((x) => x.productId === item?.productId),
        [ImeiProduct, item?.productId],
    );

    return (
        <SubCard
            title={matchDownSM ? 'x' + item.amount : item?.productName + ' x' + item.amount}
            contentSX={{ p: 0 }}
            show={true}
            secondary={
                <Paper component="form" sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }} elevation={3}>
                    {/* <IconButton
                        sx={{ p: '10px' }}
                        aria-label="menu"
                        //   onClick={() => {
                        //       setImeiScan('');
                        //   }}
                    >
                        <ConfirmationNumberIcon />
                    </IconButton> */}
                    <Box sx={{ paddingRight: '15px' }}>
                        <Badge color="secondary" badgeContent={DataProduct.length} showZero max={999}>
                            <ShoppingCartIcon />
                        </Badge>
                    </Box>
                    <InputBase
                        autoFocus
                        name="imei"
                        type="text"
                        value={ImeiScan}
                        onChange={(e) => {
                            setImeiScan(e.target.value);
                        }}
                        sx={{ ml: 1, flex: 1, maxWidth: matchDownSM ? 100 : 300 }}
                        placeholder={' ' + item?.model}
                        inputProps={{ 'aria-label': 'Scan IMEI ' + item?.model }}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                //   handleSubmit();
                                handleSubmitIMEI(e.target.value, item.productId).then(() => {
                                    setImeiScan('');
                                });
                                //   play();
                            }
                            //e.charCode === 13 && e.preventDefault();
                        }}
                    />
                    <IconButton
                        // sx={{ p: '10px' }}
                        aria-label="Camera"
                        onClick={() => {
                            setScanOpen(true);
                        }}
                    >
                        <CameraIcon />
                    </IconButton>
                    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                    <IconButton
                        color="primary"
                        sx={{ p: '10px' }}
                        aria-label="directions"
                        //   disabled={isSubmitting}
                        onClick={() => {
                            //   handleSubmit();
                            //   play();
                            handleSubmitIMEI(ImeiScan, item.productId).then(() => {
                                setImeiScan('');
                            });
                        }}
                    >
                        <DirectionsIcon />
                    </IconButton>
                </Paper>
            }
        >
            <BarcodeScanner
                Open={ScanOpen}
                setOpen={setScanOpen}
                onUpdate={(err, result) => {
                    if (result) {
                        setImeiScan(result);
                        handleSubmitIMEI(result, item.productId).then(() => {
                            setImeiScan('');
                        });
                    }
                }}
            />
            <Grid container spacing={1} sx={{ p: 1 }}>
            {DataProduct.map((params, idx) => (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    key={params?.stockcontrollers?.imei || params?.stockcontrollers?._id || idx}
                >
                    <ListItemWrapper
                        sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            height: '100%',
                            padding: 1.5,
                        }}
                    >
                        <ListItem alignItems="center">
                            <ListItemAvatar>
                                {params.images[0].img ? (
                                    <Avatar
                                        src={params.images[0].img}
                                        variant="rounded"
                                        sx={{
                                            // color: theme.palette.primary.dark,
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            borderColor: theme.palette.primary.main
                                        }}
                                    />
                                ) : (
                                    <Avatar
                                        variant="rounded"
                                        sx={{
                                            color: theme.palette.primary.dark,
                                            backgroundColor: theme.palette.primary.light,
                                            border: 'none',
                                            borderColor: theme.palette.primary.main
                                        }}
                                    >
                                        <PanoramaIcon />
                                    </Avatar>
                                )}
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <Typography variant="subtitle1">
                                        {params.productName + ' '}
                                        <Typography variant="caption" color="#0c4da2" noWrap>
                                            {params?.stockcontrollers?.type}
                                        </Typography>
                                    </Typography>
                                }
                            />
                        </ListItem>
                        <Grid container direction="column" className="list-container">
                            <Grid item xs={12}>
                                <Stack>
                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle1" noWrap color="gray">
                                            Model:
                                        </Typography>
                                        <Typography variant="button" noWrap>
                                            {params.model}{' '}
                                        </Typography>
                                    </Stack>
                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle1" noWrap color="gray">
                                            Ram:
                                        </Typography>
                                        <Typography variant="button" noWrap color="#0c4da2">
                                            {params.memory}
                                        </Typography>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1" noWrap color="gray">
                                                Storage:
                                            </Typography>
                                            <Typography variant="button" noWrap color="#0c4da2">
                                                {params.storage}
                                            </Typography>
                                        </Stack>
                                    </Stack>

                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle1" noWrap color="gray">
                                            Price(₭):
                                        </Typography>
                                        <Typography variant="button" color="#f57224">
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={params.stockcontrollers && params.stockcontrollers.salePrice}
                                                prefix=""
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                            />
                                        </Typography>
                                    </Stack>

                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle1" noWrap color="gray">
                                            IMEI:
                                        </Typography>
                                        <Typography variant="button" noWrap>
                                            {params.stockcontrollers && params.stockcontrollers.imei}
                                        </Typography>
                                    </Stack>
                                    <Stack direction="row" spacing={1}>
                                        <Typography variant="subtitle1" noWrap color="gray">
                                            locationCode:
                                        </Typography>
                                        <Typography variant="button" noWrap color="#0c4da2">
                                            {params.stockcontrollers && params.stockcontrollers?.locationCode}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant="button" noWrap color="#0c4da2">
                                            {params.categorys?.categoryName}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                const RemoveIMEI = ImeiProduct.filter(
                                                    (x) => x.stockcontrollers.imei !== params.stockcontrollers.imei
                                                );
                                                console.log(RemoveIMEI);
                                                setImeiProduct(RemoveIMEI);
                                            }}
                                        >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </ListItemWrapper>
                </Grid>
            ))}
            </Grid>
        </SubCard>
    );
};
